import { Injectable, Inject, EventEmitter } from '@angular/core'
import { SentryErrorHandler, ErrorHandlerOptions } from '@sentry/angular-ivy'
import { greenStatusCodes } from '../libs/logging.lib'

export interface Options extends ErrorHandlerOptions {}

@Injectable({ providedIn: 'root' })
export class ErrorHandlerService extends SentryErrorHandler {
  /** Emits each time an error is handled by this instance */
  onError = new EventEmitter()

  constructor(@Inject('options') options?: ErrorHandlerOptions) {
    super(options)
    this._options.extractor = (e: any) =>
      e?.rejection || this._defaultExtractor(e)
  }

  setShowDialog(show: boolean) {
    this._options.showDialog = show
  }

  override handleError(e: any) {
    // Loading chunk error
    const chunkFailedMessage = /Loading chunk [a-zA-Z0-9_\-.]+ failed/
    if (chunkFailedMessage.test(e?.message)) {
      window.location.reload()
    }

    e = this._extractError(e)
    this.onError.emit(e)

    // Ignore RxJS EmptyError
    // These errors are complicated to solve, so for now we just ignore them
    // TODO: Solve this. Sentry says they come from calling https://orderpod.app/auth/login
    if (e?.name === 'EmptyError' || e?.message === 'no elements in sequence') {
      return
    }

    // Ignore throttle queue overflow
    // These errors are complicated to solve, so for now we just ignore them
    // TODO: Solve this. Sentry says they come from Porro and within throttle.service.ts
    if (e?.message === 'Queue size limit reached') {
      return
    }

    const statusCode = parseInt(`${e}`.replace(/\D/g, ''))
    if (greenStatusCodes(statusCode)) {
      return
    }

    super.handleError(e)
  }
}
